import { useWorkspace } from '@/features/workspaces/hooks';
import { DestinationsIcon } from '@/lib';
import { useGetWorkspaceMetricsQuery } from '@/services/endpoints/metrics';
import { FC, useMemo } from 'react';
import { HomeDataSection } from '../../common';
import { HomeDestinationsChartWidget } from './HomeDestinationsChartWidget';

export const HomeDestinationsSection: FC = () => {
  const workspace = useWorkspace();
  const { data: metrics, isFetching } = useGetWorkspaceMetricsQuery(
    { workspaceId: workspace.id },
    {
      refetchOnMountOrArgChange: true,
    }
  );

  const total = useMemo(() => {
    if (!metrics?.distributionChannels) return 0;

    return Object.values(metrics.distributionChannels).reduce((sum, value) => sum + (typeof value === 'number' ? value : 0), 0);
  }, [metrics?.distributionChannels]);

  return (
    <HomeDataSection
      icon={<DestinationsIcon />}
      title={'home.destinationsTitle'}
      totalLabel={'home.destinationsTotalLabel'}
      totalValue={total}
      chart={<HomeDestinationsChartWidget />}
      createPath={'/destinations'}
      creteButtonText={'home.destinationsCreateButtonText'}
      showButtonIcon={false}
      isLoading={isFetching}
    />
  );
};
